import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Guid } from 'guid-typescript';
import * as _ from 'lodash';
import { IeSafeLead, IPlaceIneRegBinder, IPortalConfig, IRegDocSites, NotificationType, PlatForm, UserAccount } from 'src/app/models';
import { DocumentService, LoaderService, PortalService, RoutingService, SecurityService, StorageService } from 'src/app/services';
import { Helpers } from 'src/app/helpers';
import { Constants } from 'src/app/shared/models/constants';
import { TopNotificationService } from '../top-notification/top-notification.service';
import { MasterLogService } from '../../directives/medpt-common-event-log';

@Component({
    selector: 'medpt-place-in-regdoc',
    templateUrl: './place-in-regdoc.component.html',
    styleUrls: ['./place-in-regdoc.component.scss'],
    standalone: false
})
export class PlaceInRegdocComponent implements OnInit {
  @Input() placeIneRegBinder!: IPlaceIneRegBinder;
  private allBinderList: Array<IRegDocSites> = [];
  loading: boolean = false;
  submitted: boolean = false;
  isBinderSelection: boolean = false;
  sitesList: Array<IRegDocSites> = [];
  filteredBinderList: Array<IRegDocSites> = [];
  movedocumentform: FormGroup;
  contactmeform: FormGroup;
  currentUser: UserAccount;
  SuccessMessage: string = '';
  IncludeLearnMore: boolean = false;
  userPortalInfo: IPortalConfig = {};
  hasError = false;
  constructor(
    public modal: NgbActiveModal,
    private modelDialogService: NgbModal,
    private documentService: DocumentService,
    private securityService: SecurityService,
    private loaderService: LoaderService,
    private storageService: StorageService,
    private routingService: RoutingService,
    private notificationService: TopNotificationService,
    private portalService: PortalService,
    private formBuilder: FormBuilder,
     private masterlogService : MasterLogService) {

    this.currentUser = this.securityService.currentUserValue;

    this.loaderService.showLoader();
    this.loading = true;
    this.userPortalInfo = this.portalService.portalConfiguation.value;

    this.documentService.getSiteBinderList()
      .then((result: Array<IRegDocSites>) => {
        this.allBinderList = result;
        this.sitesList = <Array<IRegDocSites>>_.orderBy(_.map(_.uniqBy(result, (e: IRegDocSites) => { return e.SiteGuid; }), (e: IRegDocSites) => { return { SiteGuid: e.SiteGuid, SiteName: e.SiteName } }), ['SiteName', 'asc']);

        this.isBinderSelection = this.sitesList.length > 0;
        this.loading = false;
      }, () => {
        this.loading = false;
      })
      .catch(() => {
        this.loading = false;
      })
      .finally(() => {       
        this.loaderService.hideLoader();
      });

    this.movedocumentform = this.formBuilder.group({
      site: ['', Validators.required],
      binder: ['', Validators.required]
    });
    this.contactmeform = this.formBuilder.group({
      name: [Helpers.decodeEntity(this.currentUser.FullName), Validators.required],
      email: [Helpers.decodeEntity(this.currentUser.UserName), [Validators.required, Validators.pattern(Constants.REGEX_PATTERN_EMAIL)]],
      company: [Helpers.decodeEntity(this.userPortalInfo.SiteName!), Validators.required]
    });
  }

  ngOnInit(): void {

  }

  moveDocument() {
    this.submitted = true;
    this.hasError = false;
    if (this.movedocumentform.valid) {
      this.loaderService.showLoader();
      this.placeIneRegBinder.eRegDoc = { SiteGuid: this.movedocumentform.controls['site'].value, BinderGuid: this.movedocumentform.controls['binder'].value };
      this.placeIneRegBinder.PlaceSameFile = false;
      /*console.log(this.placeIneRegBinder);*/
      this.documentService.moveDocument(<string>this.userPortalInfo.SponsorName, <number>this.userPortalInfo.PortalID, this.placeIneRegBinder, this.placeIneRegBinder.PersonAssetGuid).then((response) => {

        /*console.log(response);*/

        if (!response.SuccessFlag && response.Status == "duplicate") {

          let modalInstance = this.modelDialogService.open(DuplicateConfirmationComponent, {});
          modalInstance.result.then((res: boolean) => {
            if (res) {
              this.loaderService.showLoader();
              this.placeIneRegBinder.PlaceSameFile = true;
              this.documentService.moveDocument(<string>this.userPortalInfo.SponsorName, <number>this.userPortalInfo.PortalID, this.placeIneRegBinder, this.placeIneRegBinder.PersonAssetGuid)
                .then((dupresponse) => {
                  this.notificationService.showNotification(dupresponse.Message, NotificationType.Success);
                  this.modal.dismiss('');
                }).catch(() => {
                  this.hasError = true;
                }).finally(() => {
                  this.loaderService.hideLoader();
                });
            }
          });

        } else if (response.SuccessFlag) {
          this.notificationService.showNotification(response.Message, NotificationType.Success);
          this.modal.dismiss('');
        }
        else {
          this.notificationService.showNotification(response.Message, NotificationType.Error);
        }
      }).finally(() => { this.loaderService.hideLoader(); });
    }
  }
  contactMe() {

    this.submitted = true;
    if (this.contactmeform.valid) {
      this.SuccessMessage = 'Thank you. We will contact you soon.';
      this.IncludeLearnMore = true;

      let leadForm: IeSafeLead = {
        Email: this.contactmeform.controls['email'].value, FirstName: this.contactmeform.controls['name'].value, LastName: '', Sponsor: this.routingService.getSponsorName(), ContactMe: 'Yes', LearnMore: 'No',
        Product: Helpers.getPlatformId() == PlatForm.TriPort ? "TriPort" : "CloudPort",
        RoleName: this.userPortalInfo.RoleName,
        SiteAddress1: this.userPortalInfo.Address,
        SiteAddress2: '',
        SiteAddress3: '',
        SiteCity: this.userPortalInfo.City,
        SiteCountry: this.userPortalInfo.Country,
        SiteFax: '',
        SiteName: this.contactmeform.controls['company'].value,
        SiteNumber: '',
        SitePhone: '',
        SitePostalCode: this.userPortalInfo.PostalCode,
        SiteState: this.userPortalInfo.State,
        StudyName: this.routingService.getPortalName()
      };
      //TO-DO SendContactMeEmail(leadForm)
      this.SaveLead(leadForm);
    }
  }
  SaveLeadData(LearnMore: string, CloseModel: boolean) {
    if (LearnMore === "Yes") {
      window.open('https://www.medpt.com/solutions/study-site/', '_blank', 'noreferrer');
      if (CloseModel) {
        this.modal.close();
      }
    } else {
      this.modal.close();
    }

    let contactMeForm: IeSafeLead = {
      Email: this.currentUser.UserName, FirstName: this.currentUser.FirstName, LastName: this.currentUser.LastName, Sponsor: this.routingService.getSponsorName(), ContactMe: 'No', LearnMore: LearnMore,
      Product: Helpers.getPlatformId() == PlatForm.TriPort ? "TriPort" : "CloudPort",
      RoleName: this.userPortalInfo.RoleName,
      SiteAddress1: this.userPortalInfo.Address,
      SiteAddress2: '',
      SiteAddress3: '',
      SiteCity: this.userPortalInfo.City,
      SiteCountry: this.userPortalInfo.Country,
      SiteFax: '',
      SiteName: this.userPortalInfo.SiteName,
      SiteNumber: '',
      SitePhone: '',
      SitePostalCode: this.userPortalInfo.PostalCode,
      SiteState: this.userPortalInfo.State,
      StudyName: this.routingService.getPortalName()
    };
    this.SaveLead(contactMeForm);
  }

  private async SaveLead(eSafeLead :IeSafeLead) {
    await this.storageService.InsertEsafeLead(eSafeLead);
  }
  onSiteChange() {
    if (this.movedocumentform.controls['site'] != null) {
      this.masterlogService.postLogMessage("Click","Selected is " + this.movedocumentform.controls['site'].value);     
      this.filteredBinderList = this.allBinderList.filter((item) => {
        return item.SiteGuid == this.movedocumentform.controls['site'].value
      });
    } else {
      this.filteredBinderList = [];
    }
  }

  onDontSeeMySiteBinderChange() {
    this.masterlogService.postLogMessage("Click","Checkbox checked for Don't see my site or binde" );   
    this.isBinderSelection = false;
  }
}


@Component({
    selector: 'medpt-copy-duplicate-confirm',
    template: `<div class="modal-header"><h4 class="modal-title">Warning!</h4></div>
             <div class="modal-body"><p>Document is already added to the binder. Do you wish add another copy.?</p></div>
             <div class="modal-footer">
                <button type="button" class="secondaryBtn" (click)="modal.close(false)">No</button>
                <button type="button" class="primaryBtn" (click)="modal.close(true)">Yes</button>
              </div>`,
    standalone: false
})
export class DuplicateConfirmationComponent {
  constructor(public modal: NgbActiveModal) { }
}
